import { render } from "./AuthCheck.vue?vue&type=template&id=0df12792"
import script from "./AuthCheck.vue?vue&type=script&lang=js"
export * from "./AuthCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__